// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"airplay-wave"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.5 19H2.00099L2 4H22L22 19L18.5 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6.34375 12.6762C9.46794 9.55196 14.5333 9.55196 17.6575 12.6762M9.17188 15.5036C10.734 13.9415 13.2666 13.9415 14.8287 15.5036M10.5 21L12 19.5L13.5 21L10.5 21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const AirplayWaveIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'airplay-wave',
    ref,
    icon: element,
  },
));

AirplayWaveIcon.displayName = 'AirplayWaveIcon';

export default AirplayWaveIcon;
